/**
 * LossReasonTable - Tabela de motivos de perda usando DataTable genérico
 * Princípios: DRY (reutiliza DataTable), SRP (apenas configuração de colunas)
 */
import React, { useMemo } from 'react';
import { LossReason } from '../../../../types';
import DataTable, { Column } from '../../../../components/shared/DataTable';
import ActionMenu, { createEditAction, createDeleteAction, createDuplicateAction } from '../../../../components/shared/ActionMenu';

interface LossReasonTableProps {
    reasons: LossReason[];
    isLoading?: boolean;
    onEdit: (reason: LossReason) => void;
    onDelete: (reason: LossReason) => void;
    onDuplicate: (reason: LossReason) => void;
    selectedIds?: Set<string>;
    onToggleSelection?: (id: string) => void;
    onToggleAll?: () => void;
}

const LossReasonTable: React.FC<LossReasonTableProps> = ({
    reasons, isLoading, onEdit, onDelete, onDuplicate,
    selectedIds = new Set(), onToggleSelection, onToggleAll
}) => {
    const columns: Column<LossReason>[] = useMemo(() => [
        {
            key: 'name', header: 'Nome',
            render: (reason) => <span className="font-medium text-default">{reason.name}</span>
        },
        {
            key: 'actions', header: 'Ações', align: 'right',
            render: (reason) => (
                <ActionMenu actions={[
                    createEditAction(() => onEdit(reason)),
                    createDuplicateAction(() => onDuplicate(reason)),
                    createDeleteAction(() => onDelete(reason))
                ]} />
            )
        }
    ], [onEdit, onDuplicate, onDelete]);

    return (
        <DataTable
            columns={columns}
            data={reasons}
            getRowKey={(r) => r.id}
            emptyMessage="Nenhum motivo de perda encontrado."
            isLoading={isLoading}
            selectable
            selectedIds={selectedIds}
            onToggleSelection={onToggleSelection}
            onToggleAll={onToggleAll}
        />
    );
};

export default LossReasonTable;
